module.exports = __webpack_public_path__ + "static/media/step_2.dfe15dc6.png";